import PropTypes from 'prop-types';
import React, { createContext,useRef, useContext, useEffect } from 'react';
import ReactCrop from 'react-image-crop'
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css'; // Ensure the Cropper's styles are loaded

// material-ui
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { LangContext } from '../../utils/contaxt';
import components from '../../components';
// assets
import { AppBar, Button, Dialog, Divider, IconButton, ListItemText, ListItemButton, List, Slide, Toolbar, Typography, TextField } from '@mui/material';

// import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
// import Components from 'Components';
import Swal from 'sweetalert2';
import ApiCall from '../../utils/Api';
// import Action from 'store/Action';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuDialogContent-root': {
    padding: theme.spacing(2),
    
  },
  '& .MuDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: "white"
        }}
      >
        {/* <CloseIcon /> */}
      </IconButton>
    ) : null}
  </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} timeout={1000} />);
export default function Edit_profile({firstName,lastName,imgurl,email,UpdateCount,setUpdateCount}) {

  const [cropimages,setcropimages]=useState()
  const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 16 / 9 });
  const [croppedImageUrl, setCroppedImageUrl] = useState('');
  const getCroppedImg = (src, crop) => {
    const canvas = document.createElement('canvas');
    const scaleX = src.naturalWidth / src.width;
    const scaleY = src.naturalHeight / src.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      src,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    // As a base64 encoded string
    const base64Image = canvas.toDataURL('image/jpeg');
    return base64Image;
  };
  const {lang,first_Name,Last_Name, setlang,setfirst_Name,setLast_Name} = useContext(LangContext);

  const [open, setOpen] = React.useState(false);
//   const Site_id = useSelector((state) => state.Booking.Site_id);
const [image, setImage] = useState(null);
const [FirstName, setFirstName] = useState();
const [LastName, setLastName] = useState();
const [Email, setEmail] = useState();
const [emailChanged, setEmailChanged] = useState(false);
// const [Image, setImage] = useState();

  const onSubmit = async() =>{
    try {

     console.log("🚀 ~ onSubmit ~ LastName:", LastName)
     console.log("🚀 ~ onSubmit ~ FirstName:", FirstName)
     console.log("🚀 ~ onSubmit ~ Email:", Email)
     let upLoadImage;
     
     // Check if email was changed and show verification message
     if (emailChanged && Email !== email) {
       toast.info("Email change requires verification. Please check your email for verification instructions.");
     }
     
     let imageUrl = null;
     
     // First, handle image upload if there's a new image
     if(image){
        console.log("🚀 ~ onSubmit ~ Processing image upload...");
        const imageElement = cropperRef?.current;
        const cropper = imageElement?.cropper;
        if (typeof cropper.getCroppedCanvas() === 'undefined') {
            console.log("🚀 ~ onSubmit ~ Cropper canvas is undefined, skipping image upload");
        } else {
            // Convert the canvas to a Blob and upload
            const blob = await new Promise((resolve) => {
              cropper.getCroppedCanvas().toBlob((blob) => {
                resolve(blob);
              }, 'image/jpeg');
            });

            console.log("🚀 ~ onSubmit ~ Image blob created:", blob);

            var formdata = new FormData();
            formdata.append("image", blob);
            // Add user ID to associate the image with the user
            const userId = localStorage.getItem("id");
            if (userId) {
              formdata.append("userId", userId);
              console.log("🚀 ~ onSubmit ~ Adding userId to image upload:", userId);
            }

            console.log("🚀 ~ onSubmit ~ Uploading image with formdata:", formdata);
            
            // Try uploading without userId first (like other components)
            var formdataSimple = new FormData();
            formdataSimple.append("image", blob);

            const uploadConfig = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };

            try {
              upLoadImage = await ApiCall.SECURE_API.post(`/file/upload-image`, formdataSimple, uploadConfig);
              console.log("🚀 ~ onSubmit ~ Simple upload response:", upLoadImage);
              console.log("🚀 ~ onSubmit ~ Simple upload data:", upLoadImage.data);
              console.log("🚀 ~ onSubmit ~ Simple upload data keys:", Object.keys(upLoadImage.data));
            } catch (error) {
              console.log("🚀 ~ onSubmit ~ Simple upload failed, trying with userId:", error);
              upLoadImage = await ApiCall.SECURE_API.post(`/file/upload-image`, formdata, uploadConfig);
            }
            console.log("🚀 ~ onSubmit ~ Image upload response:", upLoadImage);
            console.log("🚀 ~ onSubmit ~ Image upload data:", upLoadImage.data);
            console.log("🚀 ~ onSubmit ~ Image upload data keys:", Object.keys(upLoadImage.data));
            
            // Try different possible field names for the image URL
            imageUrl = upLoadImage.data.imageUrl || upLoadImage.data.url || upLoadImage.data.image || upLoadImage.data.path || upLoadImage.data.data?.imageUrl || upLoadImage.data.data?.url;
            console.log("🚀 ~ onSubmit ~ Image uploaded successfully:", imageUrl);
            
            if (!imageUrl) {
              console.error("🚀 ~ Image upload failed - no URL returned");
              console.log("🚀 ~ Full response structure:", JSON.stringify(upLoadImage, null, 2));
              
              // Check if the response has a different structure
              if (upLoadImage.data && upLoadImage.data.data) {
                console.log("🚀 ~ Checking nested data structure:", upLoadImage.data.data);
                imageUrl = upLoadImage.data.data.imageUrl || upLoadImage.data.data.url || upLoadImage.data.data.image;
              }
              
              if (!imageUrl) {
                console.log("🚀 ~ No image URL found in any structure, skipping image upload");
                imageUrl = null; // Don't include image in profile update
              }
            }

            setlang(imageUrl);
            localStorage.setItem("image", imageUrl);
        }
     }
     
     // Update the profile with basic data
     const profileData = {
       "institutionName": FirstName, // Use institutionName instead of firstName
       "email": Email
     };
     
     // If image was uploaded, include it in the profile update
     if (imageUrl) {
       profileData.profileImage = imageUrl;
       console.log("🚀 ~ onSubmit ~ Including profileImage in update:", imageUrl);
     }

     console.log("🚀 ~ onSubmit ~ Updating profile with data:", profileData);
     console.log("🚀 ~ onSubmit ~ API endpoint: /provider/EditProfile");
     
     const UpdateProfile = await ApiCall.SECURE_API.post(`/provider/EditProfile`, profileData);
     console.log("🚀 ~ onSubmit ~ Profile update response:", UpdateProfile)
     console.log("🚀 ~ onSubmit ~ Response data:", UpdateProfile.data)
     console.log("🚀 ~ onSubmit ~ Response data.data:", UpdateProfile.data.data)
     console.log("🚀 ~ onSubmit ~ Response success:", UpdateProfile.data.success)
     
     // If image was uploaded, the backend should automatically associate it with the user
     // We've already updated the context and localStorage, so the UI should reflect the change

     // Update context with the response data
     if (UpdateProfile.data.data.institutionName) {
       setfirst_Name(UpdateProfile.data.data.institutionName);
     }
     setLast_Name(""); // Clear lastName since it's not used for providers

     console.log("🚀 ~ onSubmit ~ Profile updated successfully")
 
     toast.success("Profile updated successfully");
     setUpdateCount(UpdateCount + 1);
     handleClose()
      
    } catch (error) {
     //  Action.AlertBox.Show(false)
      setUpdateCount(UpdateCount + 1)
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
      console.error("Error submitting data:", error);
    }
  }
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
         setUpdateCount(UpdateCount + 1)
                  console.log("🚀 ~ handleClose ~ UpdateCount:", UpdateCount)

    setOpen(false);
  };


useEffect(()=>{
     console.log("🚀 ~ useEffect ~ lastName:", lastName)
     console.log("🚀 ~ useEffect ~ firstName:", firstName)
     console.log("🚀 ~ useEffect ~ email:", email)
     
     setImage(imgurl)
     setFirstName(firstName)
     setLastName(lastName)
     setEmail(email)
},[lastName,firstName,imgurl,email])
const onCropComplete = (croppedArea, croppedAreaPixels) => {
  console.log("🚀 ~ onCropComplete ~ croppedAreaPixels:", croppedAreaPixels)
  console.log("🚀 ~ onCropComplete ~ croppedArea:", croppedArea)
  
  const imageElement = document.createElement('img');
  imageElement.src = image;
  const croppedImage = getCroppedImg(imageElement, croppedAreaPixels);
  console.log("🚀 ~ onCropComplete ~ croppedImage:", croppedImage)
  setCroppedImageUrl(croppedImage);
}


const cropperRef = useRef(null);
const handleFileChange = (e) => {
  console.log("🚀 ~ handleFileChange ~ e.target.files:", e.target.files)
    if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };
        reader.readAsDataURL(e.target.files[0]);
    }
};
const handleCrop = () => {
  console.log("🚀 ~ handleCrop ~ Starting crop process...");
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    
    if (!cropper) {
      console.log("🚀 ~ handleCrop ~ No cropper instance found");
      return;
    }
    
    if (typeof cropper.getCroppedCanvas() === 'undefined') {
      console.log("🚀 ~ handleCrop ~ Cropper canvas is undefined");
      return;
    }
    
    console.log("🚀 ~ handleCrop ~ Getting cropped canvas...");
    // Convert the canvas to a Blob and upload
    cropper.getCroppedCanvas().toBlob((blob) => {
      console.log("🚀 ~ handleCrop ~ Blob created:", blob);
      console.log("🚀 ~ handleCrop ~ Blob size:", blob.size);
      console.log("🚀 ~ handleCrop ~ Blob type:", blob.type);

        const formData = new FormData();
        formData.append('image', blob, 'profile.jpg'); // Use 'image' to match server expectation
        console.log("🚀 ~ handleCrop ~ FormData created:", formData);

        onSave(formData); // Call the onSave function, which should handle the API request
    }, 'image/jpeg');
};

// Add the missing onSave function
const onSave = async (formData) => {
  try {
    console.log("🚀 ~ onSave ~ Starting image upload...");
    console.log("🚀 ~ onSave ~ formData:", formData);
    
    // Add user ID to associate the image with the user
    const userId = localStorage.getItem("id");
    if (userId) {
      formData.append("userId", userId);
      console.log("🚀 ~ onSave ~ Adding userId to image upload:", userId);
    }
    
    const uploadConfig = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    const upLoadImage = await ApiCall.SECURE_API.post(`/file/upload-image`, formData, uploadConfig);
    console.log("🚀 ~ onSave ~ Upload response:", upLoadImage);
    console.log("🚀 ~ onSave ~ Image URL:", upLoadImage.data.imageUrl);
    
    setlang(upLoadImage.data.imageUrl);
    setUpdateCount(UpdateCount + 1);
    localStorage.setItem("image", upLoadImage.data.imageUrl);
    console.log("🚀 ~ onSave ~ Image set in context and localStorage");
    toast.success("Profile picture updated successfully");
  } catch (error) {
    console.error("Error uploading image:", error);
    console.error("Error details:", error.response?.data);
    toast.error("Failed to upload profile picture");
  }
};

const deleteimage=async()=>{
  try {
    console.log("🚀 ~ deleteimage ~ image:")
   let upLoadImage = await ApiCall.SECURE_API.post(`/file/upload-image?isdeleted=true`);
    
    console.log("🚀 ~ deleteimage ~ upLoadImage:", upLoadImage)
    console.log("🚀 ~ deleteimage ~ upLoadImage?.data?.imageUrl:", upLoadImage?.data?.imageUrl)
    setUpdateCount(UpdateCount + 1)
    setImage("")
    setlang(upLoadImage?.data?.imageUrl)
    localStorage.setItem("image",upLoadImage?.data?.imageUrl)
    toast.success(upLoadImage.data.message)
    
    
  } catch (error) {
    console.log("🚀 ~ deleteimage ~ error:", error)
    
  }
}


  return (
    <div>
      <Button style={{ }} variant="outlined" onClick={handleClickOpen}>
        Edit
      </Button>
      <BootstrapDialog
        fullWidth="sx"
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
          <BootstrapDialogTitle
          sx={{ position: 'relative', color: 'black',fontSize:20 }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Edit Profile
        </BootstrapDialogTitle>
        <DialogContent dividers>
        <div style={{}}>
           
               
            <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Institution Name</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField value={FirstName} onChange={(e)=>{
                         setFirstName(e.target.value)
                        }} style={{width:"100%"}} id="outlined-basic"  variant="outlined" />
                            {/* <input placeholder='Enter Your Institution Name' type='text' /> */}
                        </div>
                 </div>
                 <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Email</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField value={Email} onChange={(e)=>{
                         setEmail(e.target.value)
                         setEmailChanged(true)
                        }} style={{width:"100%"}} id="outlined-basic"  variant="outlined" type="email" />
                            {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
                        </div>
                        {emailChanged && (
                          <div style={{marginTop: 5, fontSize: '12px', color: '#ff9800'}}>
                            ⚠️ Email change requires verification
                          </div>
                        )}
                 </div>
                 <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Upload Images</span>
                      </div>

                        <div style={{marginTop:10}}>
                          <components.imagePicker setImage={setImage}/>
                          {image && (
        <div>
          <h2>Selected Image:</h2>
          {/* <ReactCrop 
           onComplete={onCropComplete}
          crop={crop} onChange={(c) => {
            console.log("🚀 ~ Edit_profile ~ c:", c)
            
            setCrop(c)}}>
      <img src={URL.createObjectURL(Image)} />
    </ReactCrop>  */}
      <div>
            {image && (
                <div>
                    <Cropper
                        src={image}
                        style={{ height: 400, width: '100%' }}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        guides={false}
                        ref={cropperRef}
                        viewMode={1}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                    />
                    <div style={{ marginTop: '10px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <Button 
                        variant="contained" 
                        color="primary"
                        onClick={handleCrop}
                        style={{ backgroundColor: '#1976d2' }}
                      >
                        Crop & Upload Image
                      </Button>
                      <Button 
                        variant="outlined" 
                        color="error"
                        onClick={()=>{
                          deleteimage()
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                </div>
            )}
        </div>
    
           </div>
      )}
                        {/* <TextField  type='file'   onChange={(e) => {
                               console.log("🚀 ~ Edit_profile ~ e.target.files[0]:", e.target.files[0])

    setImage(e.target.files[0]); // Access the first file in the FileList
  }}  style={{width:"100%"}} id="outlined-basic"  variant="outlined" /> */}
                            {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
                        </div>
                 </div>
               
               

            
      </div> 
          {/* <div style={{ width: '100%', backgroundColor: '#F3F4F8', paddingBottom: 30 }}>
   
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{}} className="ProviderTitle">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              color: Color.MainColor,
              fontSize: 40,
              fontWeight: 500,
              padding: 15,
              marginTop: 10
            }}
          >
            <span>Add Room</span>
            <Divider style={{ fontSize: 40 }} />
          </div>
          <span style={{ alignSelf: 'center', fontSize: 18, color: Color.SubHeading_Color, letterSpacing: '0.2em' }}>
            You Can Add Room From Here
          </span>
        
       
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              color: Color.MainColor,
              fontSize: 40,
              fontWeight: 500,
              padding: 15,
              marginTop: 10
            }}
          >
            <span>Add Room</span>
            <Divider style={{ fontSize: 40 }} />
          </div>
          <span style={{ alignSelf: 'center', fontSize: 18, color: Color.SubHeading_Color, letterSpacing: '0.2em' }}>
            You Can Add Room From Here
          </span>
        

          <div style={{ display: 'flex', width: '90%', alignSelf: 'center', justifyContent: 'flex-end', paddingBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Button onClick={()=>{setOpen(false)}} style={{ color: Color.MainColor, borderColor: Color.MainColor }} variant="outlined">
                Cancel
              </Button>
              <Button  style={{ backgroundColor: Color.MainColor, marginLeft: 10 }} variant="contained">
                Add
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div> */}
        </DialogContent>
        <DialogActions>
        <Button style={{ }} onClick={handleClose}  >
            Cancel
          </Button>
          <Button style={{ }} onClick={onSubmit} autoFocus >
            SAVE
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
